import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import { blue } from '@mui/material/colors';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
import { makeStyles } from 'tss-react/mui';
const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    danger: ErrorIcon,
    info: InfoIcon,
};
const useStyles = makeStyles()(theme => ({
    success: {
        backgroundColor: theme.palette.ok.dark,
    },
    danger: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: blue[700],
    },
    warning: {
        backgroundColor: theme.palette.warning.dark,
    },
    alert: {
        marginBottom: theme.spacing(0.25),
        maxWidth: 'initial',
        flexWrap: 'nowrap',
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
        display: 'flex',
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
}));
export const Alert = React.forwardRef((props, ref) => {
    const { action, className, message, variant } = props;
    const { classes, cx } = useStyles();
    const alertVariant = variant || 'info';
    const Icon = variantIcon[alertVariant];
    return (_jsx(SnackbarContent, { action: action, ref: ref, className: cx(classes.alert, classes[alertVariant], className), message: _jsxs("span", { className: classes.message, children: [_jsx("div", { className: classes.iconVariant, children: _jsx(Icon, {}) }), message] }) }));
});
